import { mensagemPadrao } from 'src/dados-estaticos'
import * as Yup from 'yup'
const tipoArquivo = Yup.string().required(mensagemPadrao)

export const schemaInserirRelatorio = Yup.object().shape({
  arquivo: tipoArquivo
})
